import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import SectionLabel from "../components/SectionLabel";
import { METRICS } from "../data/site";

function parse(value) {
  const m = value.match(/^(\d+)(\D*)$/);
  return m ? { num: parseInt(m[1], 10), unit: m[2] } : { num: 0, unit: value };
}

function Metric({ value, suffix, label, delay }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const { num, unit } = parse(value);
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const t0 = performance.now();
    const dur = 1600;
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * num));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, num]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
      className="border-t border-white/[0.1] pt-8"
      data-testid="metric"
    >
      <div className="text-metric">
        {n}
        {unit}
      </div>
      {suffix && <div className="mt-2 text-2xl md:text-3xl thin text-lav-400">{suffix}</div>}
      <div className="label mt-6 text-white/45">{label}</div>
    </motion.div>
  );
}

export default function Metrics() {
  return (
    <section className="px-6 md:px-12 lg:px-16 py-32 md:py-48" data-testid="metrics">
      <SectionLabel index="07">NUMBERS MATTER</SectionLabel>
      <div className="mt-16 grid grid-cols-1 gap-x-12 gap-y-16 sm:grid-cols-2 lg:grid-cols-4">
        {METRICS.map((m, i) => (
          <Metric key={m.label} {...m} delay={i * 0.08} />
        ))}
      </div>
    </section>
  );
}
